import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PageHeader from "../../components/common/PageHeader";
import { getAccounts } from "../../api/accountingApi";

export default function ChartOfAccounts() {

  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {

    const res = await getAccounts();

    // ⭐ FIX: ensure accounts is always an array
    setAccounts(Array.isArray(res.data) ? res.data : []);

  };

  return (
    <Box className="page">

      <PageHeader title="Chart of Accounts" />

      {accounts.map((a) => (
        <div key={a.id}>
          {a.code} — {a.name}
        </div>
      ))}

    </Box>
  );
}